/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  Paper,
  Button,
  DialogTitle,
  DialogActions,
  Dialog,
  DialogContent,
} from "@material-ui/core";

/**
 * region for redux*/
import { connect } from "react-redux";
import { IdentifySupplierJobsActions } from "../../actions/IdentifySupplierJobsActions";

/**
 * region for styles*/
import { headerSupplierJobsStyle } from "./style/headerSupplierJobsStyle";

/**
 * region for hepers*/
import Constants from "../../constants/Constants";

class HeaderSupplierJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constants.MODE_LOADED,
      openDialog: false,
      urlText: "",
      openDialogCrawl: false,
      urlTextCrawl: "",
    };
  }

  /*Modal URL*/
  handleOnClickDialogOpen(event) {
    this.setState({ openDialog: true });
  }

  handleOnClickDialogClose(event) {
    this.setState({ openDialog: false });
  }

  handleOnClickDialogSave(event) {
    let self = this;
    let urls = this.state.urlText.split("\n");
    self.setState({ openDialog: false, urlText: "" }, function () {
      self.props.setUrls(urls);
    });
  }

  handleOnChangeUrls(event) {
    event.preventDefault();
    this.setState({
      urlText: event.target.value,
    });
  }

  /*Modal Crawl URL*/
  handleOnClickDialogCrawlOpen(event) {
    this.setState({ openDialogCrawl: true });
  }

  handleOnClickDialogCrawlClose(event) {
    this.setState({ openDialogCrawl: false });
  }

  handleOnClickDialogCrawlSave(event) {
    let self = this;
    let urls = this.state.urlTextCrawl.split("\n");
    self.setState({ openDialogCrawl: false, urlTextCrawl: "" }, function () {
      self.props.setCrawlUrls(urls);
    });
  }

  handleOnChangeCrawlUrl(event) {
    event.preventDefault();
    this.setState({
      urlTextCrawl: event.target.value,
    });
  }

  render() {
    let self = this;
    const { classes } = self.props;
    return (
      <Paper elevation={0} className={classes.paper} square={true}>
        <Grid
          container
          direction="row-reverse"
          justifycontent="flex-end"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Button
              variant="outlined"
              size="large"
              color="inherit"
              fullWidth
              onClick={self.handleOnClickDialogOpen.bind(this)}
            >
              Analyze a list of URLs
            </Button>
          </Grid>
          <Grid item xs={2} className="mr-1">
            <Button
              variant="outlined"
              size="large"
              color="inherit"
              fullWidth
              onClick={self.handleOnClickDialogCrawlOpen.bind(this)}
            >
              Crawl URL
            </Button>
          </Grid>
        </Grid>
        <Dialog
          open={self.state.openDialogCrawl}
          keepMounted
          onClose={self.handleOnClickDialogCrawlClose.bind(this)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Crawl URL</DialogTitle>
          <DialogContent>
            <TextField
              label="URL"
              rows={1}
              variant="outlined"
              fullWidth
              onChange={this.handleOnChangeCrawlUrl.bind(this)}
              value={self.state.urlTextCrawl}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={self.handleOnClickDialogCrawlClose.bind(this)}
              color="primary"
            >
              Close
            </Button>
            <Button
              onClick={self.handleOnClickDialogCrawlSave.bind(this)}
              color="primary"
              disabled={self.state.urlTextCrawl.length > 0 ? false : true}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={self.state.openDialog}
          keepMounted
          onClose={self.handleOnClickDialogClose.bind(this)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Analyze new URLs. Add one URL per line</DialogTitle>
          <DialogContent>
            <TextField
              label="URLs"
              multiline
              rows={8}
              variant="outlined"
              fullWidth
              onChange={this.handleOnChangeUrls.bind(this)}
              value={self.state.urlText}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={self.handleOnClickDialogClose.bind(this)}
              color="primary"
            >
              Close
            </Button>
            <Button
              onClick={self.handleOnClickDialogSave.bind(this)}
              color="primary"
              disabled={self.state.urlText.length > 0 ? false : true}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

HeaderSupplierJobs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {}

const mapDispatchToProps = (dispatch) => {
  return {
    setUrls: (urls) => dispatch(IdentifySupplierJobsActions.setUrls(urls)),
    setCrawlUrls: (urls) => dispatch(IdentifySupplierJobsActions.setCrawlUrls(urls)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(headerSupplierJobsStyle)(HeaderSupplierJobs));
